module.exports = __webpack_public_path__ + "img/DEM_Door_REV_H.533733c9.png";